import {actions} from '../util/actions';



/* Auth */
export const userLogin = (loginResponse) => ({
  type: actions.USER_LOGIN_ASYNC,
  loginResponse
});

export const userLogout = () => ({
  type: actions.LOG_OUT
})

export const getAdminRoles = () => ({
  type: actions.GET_ADMIN_ROLES
})

export const becomeUser = (user_id) => ({
  type: actions.BECOME_USER,
  user_id
});

export const unbecomeUser = () => ({
  type: actions.UNBECOME_USER,
});

/*SSO Login*/
export const googleSSOLogin = (id_token, email, captcha_token, honeypotPayload) => ({
  type: actions.GOOGLE_SSO_LOGIN,
  id_token: id_token,
  email: email,
  captcha_token,
  honeypotPayload,
});

export const classLinkSSOLogin = ({ code, redirectUri, pixelToken }) => ({
  type: actions.CLASSLINK_SSO_LOGIN,
  code,
  redirectUri,
  pixelToken,
});

export const microsoftSSOLogin = (payload) => {
  if (typeof payload === "string") {
    return {
      type: actions.MICROSOFT_SSO_LOGIN,
      idToken: payload,
    };
  }

  const { idToken, pixelToken } = payload || {};
  return {
    type: actions.MICROSOFT_SSO_LOGIN,
    idToken,
    pixelToken,
  };
};

export const isafeDirectSSOLogin = ({ accessToken, email } = {}) => ({
  type: actions.ISAFE_DIRECT_SSO_LOGIN,
  accessToken,
  email,
});

/*Profile*/

export const updateProfile = (userProfile) => ({
  type: actions.UPDATE_PROFILE_INFO,
  userProfile,
});

export const updateEmailProfile = (email) => ({
  type: actions.UPDATE_PROFILE_EMAIL_INFO,
  email,
});


/* Subscriptions Details */

export const getSubscriptionDetail = (invoice_id,customer_id,customer_code) => ({
  type: actions.GET_SUBSCRIPTION_DETAIL_ASYNC,
  invoice_id,
  customer_id,
  customer_code,
});

export const storeSelectedSubscriptions = (selected_subscription) => ({
  type: actions.STORE_SELECTED_SUBSCRIPTION,
  selected_subscription
});

export const storeSubscriptionSchoolLimits = (limits) => ({
  type: actions.STORE_SUBSCRIPTION_SCHOOL_LIMITS,
  limits,
});

  /* Become Functionality */
  export const setBecome = (become) => ({
    type: actions.SET_BECOME,
    become,
  });

export const setBecomeOrigin = (origin) => ({
  type: actions.SET_BECOME_ORIGIN,
  origin,
});

export const setSelfImplemented = (value) => ({
  type: actions.SET_SELF_IMPLEMENTED,
  value,
});

export const selfImplementation = ({ user_id, value }) => ({
  type: actions.SELF_IMPLEMENTATION_ASYNC,
  user_id,
  value,
});

/* ILEARN CERTIFICATION */ 

export const updateUserILEARNProgress = (updateObj) => ({
  type: actions.UPDATE_USER_ILEARN_PROGRESS_ASYNC,
  updateObj
});



/* ISAFE AI */
export const setAgeVerification = () => ({
  type: actions.SET_AGE_VERIFICATION,
});
